import {
  doGetExternalAppRequest,
  doGetExternalAppRequestV2,
  doPostExternalAppRequest,
  doPutExternalAppRequest,
} from "./ApiService";
import { baseHeaders } from "./Headers";
import { CheckPhoneType } from "../types/UserState";
import store from "@/store";

export function checkPhone({
  phone,
  customerId,
}: CheckPhoneType): Promise<any> {
  const url = `/customer/subscriber/${phone}?gw-app-key=${process.env.VUE_APP_X_GW_APP_KEY}`;
  const headers = {
    ...baseHeaders,
    "x-uid": process.env.VUE_APP_X_UID,
    "x-customer-id": store.getters.customerId,
    authorization: "Bearer ".concat(localStorage.getItem("x-access-token")!),
  };
  return doGetExternalAppRequest(url, headers);
}

export function checkBalance(): Promise<any> {
  const url = `/customer/tobe/balance/${store.getters.msisdn}?gw-app-key=${process.env.VUE_APP_X_GW_APP_KEY}`;
  const headers = {
    ...baseHeaders,
    "x-uid": process.env.VUE_APP_X_UID,
    "x-customer-id": store.getters.customerId,
    authorization: "Bearer ".concat(localStorage.getItem("x-access-token")!),
  };
  return doGetExternalAppRequest(url, headers);
}

export async function validEmailCode(payload: any): Promise<any> {
  const url = `/customer/reset-password/token/valid?gw-app-key=${process.env.VUE_APP_X_GW_APP_KEY}`;
  const headers = {
    ...baseHeaders,
    "x-uid": process.env.VUE_APP_X_UID,
  };
  const response = await doPostExternalAppRequest<any>(url, payload, headers);
  return response;
}

export async function resetPassword(payload: any): Promise<any> {
  const url = `/customer/reset-password/token?gw-app-key=${process.env.VUE_APP_X_GW_APP_KEY}`;
  const headers = {
    ...baseHeaders,
    "x-uid": process.env.VUE_APP_X_UID,
  };
  const response = await doPostExternalAppRequest<any>(url, payload, headers);
  return response;
}

export async function changePassword(payload: any): Promise<any> {
  const url = `/customer/reset-password?gw-app-key=${process.env.VUE_APP_X_GW_APP_KEY}`;
  const headers = {
    ...baseHeaders,
    "x-uid": process.env.VUE_APP_X_UID,
  };
  const response = await doPutExternalAppRequest<any>(url, payload, headers);
  return response;
}

export function checkCpf(cpf: string): Promise<any> {
  const url = `/customer/${cpf}/recaptcha?gw-app-key=${process.env.VUE_APP_X_GW_APP_KEY}`;
  const headers = {
    ...baseHeaders,
    "x-uid": process.env.VUE_APP_X_UID,
    "x-recaptcha": localStorage.getItem("captcha")!,
  };
  return doGetExternalAppRequest(url, headers);
}

export function checkCpfV2(cpf: string): Promise<any> {
  const url = `/customerId/${cpf}/recaptcha?gw-app-key=${process.env.VUE_APP_X_GW_APP_KEY}`;
  const headers = {
    ...baseHeaders,
    "x-uid": process.env.VUE_APP_X_UID,
    "x-recaptcha": localStorage.getItem("captcha")!,
  };
  return doGetExternalAppRequestV2(url, headers);
}

export function validCpf(cpf: string): Promise<any> {
  const url = `/customer/check/${cpf}?gw-app-key=${process.env.VUE_APP_X_GW_APP_KEY}`;
  const headers = {
    ...baseHeaders,
    "x-uid": process.env.VUE_APP_X_UID,
    "x-recaptcha": localStorage.getItem("captcha")!,
  };
  return doGetExternalAppRequest(url, headers);
}

export function forgotPwd(cpf: string): Promise<any> {
  const url = `/customer/reset-password/options/${cpf}?gw-app-key=${process.env.VUE_APP_X_GW_APP_KEY}`;
  const headers = {
    ...baseHeaders,
    "x-uid": process.env.VUE_APP_X_UID,
    "x-recaptcha": localStorage.getItem("captcha")!,
  };
  return doGetExternalAppRequest(url, headers);
}
